import sadLogoIcon from "../assets/img/sad-logo.png";
import { useSpring, animated } from "@react-spring/web";
import { useEffect } from "react";

export function MessageAccountDeleted() {
  const propsUseSpring = useSpring({
    from: { width: "0%" },
    to: { width: "100%" },
    config: { duration: 10000 },
  });

  useEffect(() => {
    setTimeout(() => {
      window.location.href = "/";
    }, 10000);
  }, []);

  return (
    <div className="style-container-loading-page">
      <div className="d-flex flex-column align-items-center text-center">
        <img
          src={sadLogoIcon}
          alt="check"
          className="style-size-image-account-deleted"
        />

        <div className="style-empty-row-account-deleted"></div>

        <p className="text-light fw-bold style-fs-text-account-deleted">
          Sua conta foi excluída.<br />
          Sentiremos muito a sua falta e esperamos te ver por aqui novamente em breve. 
        </p>

        <div
          style={{
            marginTop: "3%",
            width: "100%",
            maxWidth: "80%",
            height: "5px",
            background: "transparent",
          }}
        >
          <animated.div
            style={{
              ...propsUseSpring,
              height: "100%",
              background: "#FFF",
              borderRadius: "50px",
            }}
          />
        </div>
      </div>
    </div>
  );
}
